import axios from 'axios';

const dictionaryDefinitionApi = (dictionaryDefinitionApiUrl, term, productLineId) => axios({
  params: {
    term,
    productLineId,
  },
  url: dictionaryDefinitionApiUrl,
  method: 'GET',
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default dictionaryDefinitionApi;
